import React, { useLayoutEffect, useState } from 'react';

import * as S from './styles';
import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';
import { CarouselImagesProps } from 'types/CarouselImagesProps';
import { png } from 'utils/imgList';
import Carousel from 'components/Carousel';

interface DefaultProps {
	bannersData: DataFormCarroselBannersProps;
}

export default function Default({ bannersData }: DefaultProps) {
	const [arrayIms, setArrayImgs] = useState<CarouselImagesProps[]>([]);

	useLayoutEffect(() => {
		if (bannersData.banners.length > 0) {
			const listOfImgs: CarouselImagesProps[] = bannersData.banners.map(
				(banner, i) => ({
					id: banner?.image?.id || i,
					imageUrl: banner?.image?.relativePath || png.genericImage
				})
			);
			setArrayImgs(listOfImgs);
		}
	}, [bannersData]);

	return (
		<S.container>
			{arrayIms.length > 0 ? (
				<Carousel items={arrayIms} showClicks={false} isBtns={false} />
			) : (
				<S.noBanners>
					<p>Não imagens para o carrossel</p>
				</S.noBanners>
			)}
		</S.container>
	);
}
